module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00036.15c95809.png";